import { Immutable } from "immer";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CmsColumnBlock } from "@/gen/realtime";

export const ColumnForm = ({ block }: { block: Immutable<CmsColumnBlock> }) => {
    return (
        <div className="flex-grow space-y-6">
            <Card>
                <CardHeader>
                    <CardTitle>Column Configuration</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="text-muted-foreground text-sm">
                        This column contains {block.blocks.length} block
                        {block.blocks.length !== 1 ? "s" : ""}. You can add or remove blocks in the
                        layout editor.
                    </div>
                    {/* If additional column configuration options are needed, add them here */}
                </CardContent>
            </Card>
        </div>
    );
};
